import api from "../../axios";

export const createAssessmentFactor = (data) =>{
    return api.post("/api/XPRSSurveyAnalysis/assessment-factors", data);
};

export const getAssessmentFactor = (assessmentUID) =>{
    return api.get("/api/XPRSSurveyAnalysis/assessment-factors", {
        params: {
            assessmentUID,
        },
    });
};

export const saveQuestionAnalytics = (payload) => {
  return api.post(
    "/api/XPRSSurveyAnalysis/question-analysis",
    payload
  );
};

export const getQuestionAnalytics = (questionUID) =>{
    return api.get("/api/XPRSSurveyAnalysis/question-analysis", {
        params: {
            questionUID,
        },
    });
};


export const getScoringConfig = (surveyUID) => {
    return api.get("/api/XPRSSurveyAnalysis/scoring-config", {
        params: {
            surveyUID,
        },
    });
};
 
export const saveScoringConfig = (payload) => {
    return api.post("/api/XPRSSurveyAnalysis/scoring-config", payload);
};

export const deleteAssessmentFactor = (payload) => {
  return api.post("/api/XPRSSurveyAnalysis/Delete-Assessment-Factor", payload);
};